import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { BusComponent } from '../bus/bus.component';

@Component({
  selector: 'app-bus-list',
  templateUrl: './bus-list.component.html',
  styleUrls: ['./bus-list.component.css']
})
export class BusListComponent implements OnInit {

  public menu_item_id = '88';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['bus_no', 'seats_num', 'country_name', 'city_name', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<BusComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'bus', 'bus_no': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['bus_no'] != '')
      condition += " `bus_no` LIKE '%" + this.model['bus_no'] + "%' AND ";

    let query = "SELECT `bus`.*, `city`.`city_name`, `country`.`country_name`,"
      + " `country`.`country_id` FROM `bus`, `city`,`country` WHERE" + condition
      + " `bus`.`status` = '1' AND `bus`.`city_id` = `city`.`city_id` AND"
      + " `country`.`country_id` = `city`.`country_id` AND `country`.`country_id` = `bus`.`country_id`";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newBus() {
    this.addDialogRef = this.dialog.open(BusComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editBus(row) {
    let dialog_data = {
      'table_name': 'bus', 'bus_id': row.bus_id,
      'bus_no': row.bus_no,
      'seats_num': row.seats_num,
      'bus_driver1': row.bus_driver1,
      'driver1_mobile': row.driver1_mobile,
      'bus_driver2': row.bus_driver2,
      'driver2_mobile': row.driver2_mobile,
      'country_id': row.country_id,
      'city_id': row.city_id,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(BusComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delBus(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'bus_id': row.bus_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
